import {IssuePersonalData} from "../domain/entities/issue-personal-data.entity";
import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

/**
 * Assigns a Label to an Issue that currently has none (docs/feature-plans/0026-
 * personal-labels-issue-data/ follow-up, "My Organizer" reorder step, 2026-09-06)
 * — see `AssignIssueToPersonalLabelCommandHandler`'s own docblock for the full
 * responsibility split against Move/Unassign/Reorder.
 *
 * `mainEntityClass`/`mainEntityUid` MUST point at this IssuePersonalData row
 * itself, NOT at the referenced Issue — see `CreateIssuePersonalDataCommand`'s
 * own doc comment on why (privacy: pointing at the Issue would surface
 * "User X: assign.issue-to-personal-label" in the Issue's own tenant-wide
 * visible audit history).
 */
export class AssignIssueToPersonalLabelCommand extends AbstractCommand<IssuePersonalData> {

    name = CommandName.ASSIGN_ISSUE_TO_PERSONAL_LABEL;

    tags = ['entity', 'assign', 'issue-personal-data'];

}
